import React from 'react';
import roleHOC from 'HOC/roleHOC';
import loadable from "@loadable/component";
import { DOCS_MENU_VALUE } from '../../../layouts/docsumentation/constants';
import General from './content/general';


const VisualEditor = loadable(() => import(/* webpackChunkName: "VisualEditor" */ './content/themes/visual-editor/visual-editor'));
const VisualHeader = loadable(() => import(/* webpackChunkName: "VisualHeader" */ './content/themes/visual-editor/visual-header'));
const VisualFooter = loadable(() => import(/* webpackChunkName: "VisualFooter" */ './content/themes/visual-editor/visual-footer'));
const VisualPages = loadable(() => import(/* webpackChunkName: "VisualPages" */ './content/themes/visual-editor/visual-pages'));
const VisualSections = loadable(() => import(/* webpackChunkName: "VisualSections" */ './content/themes/visual-editor/visual-sections'));
const VisualSettings = loadable(() => import(/* webpackChunkName: "VisualSettings" */ './content/themes/visual-editor/visual-settings'));
const CodeEditorGlobalObject = loadable(() => import(/* webpackChunkName: "CodeEditorGlobalObject" */ './content/themes/code-editor/global-object'), { ssr: false });
const CodeEditor = loadable(() => import(/* webpackChunkName: "CodeEditor" */ './content/themes/code-editor/code-editor'));
const CodeLayouts = loadable(() => import(/* webpackChunkName: "CodeLayouts" */ './content/themes/code-editor/code-layouts'));
const CodeTemplates = loadable(() => import(/* webpackChunkName: "CodeTemplates" */ './content/themes/code-editor/code-templates'));
const CodeSections = loadable(() => import(/* webpackChunkName: "CodeSections" */ './content/themes/code-editor/code-sections'));
const CodeBlocks = loadable(() => import(/* webpackChunkName: "CodeBlocks" */ './content/themes/code-editor/code-blocks'));
const CodeAssets = loadable(() => import(/* webpackChunkName: "CodeAssets" */ './content/themes/code-editor/code-assets'));
const CodeSnippets = loadable(() => import(/* webpackChunkName: "CodeSnippets" */ './content/themes/code-editor/code-snippets'));
const CodeLocales = loadable(() => import(/* webpackChunkName: "CodeLocales" */ './content/themes/code-editor/code-locales'));
const CodeSettings = loadable(() => import(/* webpackChunkName: "CodeSettings" */ './content/themes/code-editor/code-settings'));

const Themes = loadable(() => import(/* webpackChunkName: "Themes" */ './content/themes'));
const Pages = loadable(() => import(/* webpackChunkName: "Pages" */ './content/pages'));
const Navigation = loadable(() => import(/* webpackChunkName: "Navigation" */ './content/navigation'));
const Domains = loadable(() => import(/* webpackChunkName: "Domains" */ './content/domains'));
const Emails = loadable(() => import(/* webpackChunkName: "Emails" */ './content/emails'));

import "./index.scss";

const CustomizationDocsContent = ({ selectedItem }) => {
  const renderContent = () => {
    switch (selectedItem) {
      case DOCS_MENU_VALUE.general:
        return <General />;
      case DOCS_MENU_VALUE.themes:
        return <Themes />;
      case DOCS_MENU_VALUE.visualEditor:
        return <VisualEditor />;
      case DOCS_MENU_VALUE.visualHeader:
        return <VisualHeader />;
      case DOCS_MENU_VALUE.visualFooter:
        return <VisualFooter />;
      case DOCS_MENU_VALUE.visualPages:
        return <VisualPages />;
      case DOCS_MENU_VALUE.visualSections:
        return <VisualSections />;
      case DOCS_MENU_VALUE.visualSettings:
        return <VisualSettings />;
      case DOCS_MENU_VALUE.codeEditor:
        return <CodeEditor />;
      case DOCS_MENU_VALUE.codeEditorGlobalObject:
        return <CodeEditorGlobalObject />;
      case DOCS_MENU_VALUE.codeLayouts:
        return <CodeLayouts />;
      case DOCS_MENU_VALUE.codeTemplates:
        return <CodeTemplates />;
      case DOCS_MENU_VALUE.codeSections:
        return <CodeSections />;
      case DOCS_MENU_VALUE.codeBlocks:
        return <CodeBlocks />;
      case DOCS_MENU_VALUE.codeAssets:
        return <CodeAssets />;
      case DOCS_MENU_VALUE.codeSnippets:
        return <CodeSnippets />;
      case DOCS_MENU_VALUE.codeLocales:
        return <CodeLocales />;
      case DOCS_MENU_VALUE.codeSettings:
        return <CodeSettings />;
      case DOCS_MENU_VALUE.pages:
        return <Pages />;
      case DOCS_MENU_VALUE.navigation:
        return <Navigation />;
      case DOCS_MENU_VALUE.domains:
        return <Domains />;
      case DOCS_MENU_VALUE.emails:
        return <Emails />;
    }
  };

  return renderContent();
};

export default roleHOC(CustomizationDocsContent);
